export const FOLLOW_UP_DATE = 'followUpDecisionDate';
export const FOLLOW_UP_LOCATION = 'followUpDecisionLocationId';
export const FOLLOW_UP_BY_ID = 'followUpDecisionDoneById';
export const FOLLOW_UP_BY_NAME = 'followUpDecisionDoneByName';
export const FOLLOW_UP_DECISION_ID = 'followUpDecisionId';
export const FOLLOW_UP_REFERRAL_LOCATION = 'followUpReferralLocationId';
